export default __webpack_public_path__ + "static/media/calendar.cc8556ac.svg";